// @LTG-ID: data-diagnostic
// @STATUS: BUILT @SHARED
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-012, source Landing Page.html lines 2521-2558
// @CHANGED: 2026-02 session_003 (CHG-0041)
// @OWNER: web
//
// 4-Q exit-readiness diagnostic. Max raw score = 4 × 25 = 100. Verdict bins:
// ≥80 Transaction-ready · 60–79 Tunable · 40–59 Pre-flight · <40 Not yet.
// Source `Landing Page.html` lines 2521-2583.

export const DIAG_Q = [
    {
        q: "If you couldn't work for 90 days, what happens?",
        opts: [
            { text: "The business slows but operates fine without me.", score: 25 },
            { text: "Revenue holds, but key decisions wait for me.", score: 18 },
            { text: "Things start breaking around week 3.", score: 8 },
            { text: "Honestly? It wouldn't survive.", score: 2 },
        ],
    },
    {
        q: "Your largest customer is what share of revenue?",
        opts: [
            { text: "Under 10%.", score: 25 },
            { text: "10–20%.", score: 18 },
            { text: "20–40%.", score: 8 },
            { text: "Over 40%.", score: 2 },
        ],
    },
    {
        q: "How clean are your last three years of financials?",
        opts: [
            { text: "GAAP, reviewed by a CPA firm, ready for diligence.", score: 25 },
            { text: "Accrual, internally prepared, mostly clean.", score: 18 },
            { text: "Cash-basis, some commingling.", score: 8 },
            { text: "I'd be embarrassed to show them.", score: 2 },
        ],
    },
    {
        q: "When are you considering an exit?",
        opts: [
            { text: "5+ years out, building optionality.", score: 25 },
            { text: "2 to 5 years.", score: 22 },
            { text: "12 to 24 months.", score: 15 },
            { text: "I'd take the right offer tomorrow.", score: 10 },
        ],
    },
];

// Verdict bins per source line 2580-2583.
export function diagnosticVerdict(pct) {
    if (pct >= 80) {
        return {
            verdict: "Transaction-ready",
            note: "You're in the top decile. The work now is timing and buyer selection.",
        };
    }
    if (pct >= 60) {
        return {
            verdict: "Tunable",
            note: "Strong foundations. 12 to 18 months of focused work could lift the multiple meaningfully.",
        };
    }
    if (pct >= 40) {
        return {
            verdict: "Pre-flight",
            note: "You would transact today, but at a discount. A 24-month roadmap typically recovers 20% to 40% of value.",
        };
    }
    return {
        verdict: "Not yet",
        note: "There's real upside here, but selling today would leave the majority on the table. Start with the spine.",
    };
}

// Right-rail pillars under "Why these four". Source lines 2647-2664.
export const DIAG_PILLARS = [
    {
        num: "L/08",
        title: "Delegation Index",
        text: "If the business needs you, the buyer is buying a job.",
    },
    {
        num: "L/03",
        title: "Risk Shield",
        text: "Concentration risk is the first thing a Quality-of-Earnings analyst flags.",
    },
    {
        num: "L/05",
        title: "Revenue Reliability",
        text: "Recurring & contracted revenue trades at a premium of 1.3–2.1× over project work.",
    },
    {
        num: "L/00",
        title: "Timing & readiness",
        text: "Owners who plan 36+ months out keep ~22% more of the proceeds, after tax.",
    },
];
